// extracted by mini-css-extract-plugin
export var anchor = "_4x-0";
export var discard = "_4x-4";
export var muiTooltipTooltip = "_4x-6";
export var notificationBar = "_4x-3";
export var saveButtonHoverSlotWrapper = "_4x-5";
export var show = "_4x-2";
export var spacer = "_4x-1";